export default {
  'menu.workbench': '歡迎',
  'menu.more-blocks': '更多區塊',
  'menu.home': '首頁',
  'menu.admin': '权限',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登錄',
  'menu.dashboard': '儀表板',
  'menu.dashboard.analysis': '分析頁',
  'menu.dashboard.monitor': '監控頁',
  'menu.dashboard.workplace': '工作臺',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表單頁',
  'menu.form.basic-form': '基礎表單',
  'menu.form.step-form': '分步表單',
  'menu.form.step-form.info': '分步表單（填寫轉賬信息）',
  'menu.form.step-form.confirm': '分步表單（確認轉賬信息）',
  'menu.form.step-form.result': '分步表單（完成）',
  'menu.form.advanced-form': '高級表單',
  'menu.list': '列表頁',
  'menu.list.table-list': '查詢表格',
  'menu.list.basic-list': '標淮列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（項目）',
  'menu.list.search-list.applications': '搜索列表（應用）',
  'menu.profile': '詳情頁',
  'menu.profile.basic': '基礎詳情頁',
  'menu.profile.advanced': '高級詳情頁',
  'menu.result': '結果頁',
  'menu.result.success': '成功頁',
  'menu.result.fail': '失敗頁',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '個人頁',
  'menu.account.center': '個人中心',
  'menu.account.workbench': '返回工作臺',
  'menu.account.tenantManagement': '企業管理',
  'menu.account.trigger': '觸發報錯',
  'menu.account.logout': '退出登錄',
  'menu.customer-intelligence': '客戶情報中心',
  'menu.customer-intelligence.customer-list': '客戶列表',
  'menu.customer-intelligence.customer-detail': '客戶詳情',
  'menu.settings': '系統設置',
  'menu.solution-advancement': '方案推進中心',
  'menu.solution-advancement.detail': '推進詳情',
  'menu.field-research': '現場調研',
  'menu.field-research.records': '執行記錄',
  'menu.field-research.panel': '執行面板',
  'menu.settings.code-rules': '編碼規則',
  'menu.settings.dict': '字典管理',
  'menu.settings.tag-pool': '標籤管理',
  'menu.zy-consultant-operations': '問題庫',
  'menu.zy-consultant-operations.question-bank': '問題列表',
  'menu.zy-consultant-operations.question-bank.detail': '問題詳情',
  'menu.zy-consultant-operations.question-packs': '題包',
  'menu.zy-consultant-operations.question-packs.detail': '題包詳情',
  'menu.zy-consultant-operations.diagnosis-sessions': '診斷會話',
  'menu.zy-consultant-operations.diagnosis-sessions.detail': '診斷會話詳情',
  'menu.zy-consultant-operations.diagnosis-sessions.run': '執行診斷',
  'menu.zy-consultant-operations.diagnosis-sessions.result': '診斷結果',
  'menu.methodology-center': '方法論沉澱中心',
  'menu.methodology-center.industry-cases': '行業案例庫',
  'menu.methodology-center.common-pain-points': '常見痛點庫',
  'menu.methodology-center.solution-playbooks': '解決方案庫',
  'menu.methodology-center.pilot-scenes': '試點場景庫',
  'menu.methodology-center.talk-tracks': '提問話術庫',
  'menu.methodology-center.failure-reasons': '失敗原因庫',
  'menu.methodology-center.success-playbooks': '成功打法庫',
  'menu.methodology-center.industry-templates': '行業模板庫',
  'menu.methodology-center.analysis-logics': '分析邏輯庫',
  'menu.methodology-center.library-detail': '庫內詳情',
  'menu.editor': '圖形編輯器',
  'menu.editor.flow': '流程編輯器',
  'menu.editor.mind': '腦圖編輯器',
  'menu.editor.koni': '拓撲編輯器',
};
